var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1035 2244 c-456 -49 -816 -328 -968 -751 -81 -224 -81 -512 0 -736 117 -328 364 -574 690 -690 224 -81 512 -81 736 0 456 162 750 578 750 1058 0 480 -294 896 -750 1058 -125 45 -339 73 -458 61z m325 -313 c259 -84 459 -285 538 -543 68 -220 43 -454 -71 -658 -57 -102 -205 -250 -307 -307 -463 -259 -1035 -37 -1202 467 -30 89 -32 104 -32 245 -1 169 11 230 68 352 84 176 215 311 385 398 132 66 226 86 396 81 112 -3 143 -8 225 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831 1689 c-149 -73 -267 -216 -317 -384 -22 -73 -24 -226 -5 -305 40 -167 170 -330 323 -405 77 -37 103 -40 115 -10 11 31 -16 64 -79 96 -38 19 -90 58 -131 100 -250 250 -185 659 132 828 66 35 93 70 75 99 -16 25 -24 24 -113 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 1687 c0 -38 12 -51 85 -87 68 -33 183 -151 217 -222 78 -161 77 -321 -3 -480 -38 -76 -133 -172 -209 -212 -75 -39 -90 -54 -90 -88 0 -56 54 -46 172 31 176 114 278 301 278 508 0 110 -14 172 -62 273 -33 69 -56 100 -122 165 -84 83 -187 145 -240 145 -23 0 -26 -4 -26 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077 1532 c-10 -10 -17 -35 -17 -54 0 -33 -3 -36 -35 -41 -49 -8 -90 -40 -114 -90 -27 -56 -27 -106 2 -147 30 -46 72 -68 178 -95 122 -31 141 -45 137 -97 -4 -54 -38 -80 -111 -86 -63 -5 -105 12 -137 58 -17 23 -29 30 -56 30 -44 0 -51 -17 -25 -68 24 -47 60 -75 119 -92 38 -12 42 -16 42 -47 0 -32 28 -73 50 -73 22 0 50 41 50 75 0 31 3 35 40 45 51 14 98 54 121 105 21 46 23 66 9 117 -15 54 -60 83 -176 114 -149 39 -179 63 -154 124 15 35 64 60 120 60 36 0 48 -6 88 -45 32 -32 53 -45 74 -45 84 0 9 131 -92 161 -38 11 -40 14 -40 50 0 28 -5 41 -19 49 -27 14 -35 13 -54 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.506e26feabf56c90399cbfbfcc4fba4d.svg";
export { ForwardRef as ReactComponent };